import { captureServerSideError } from '@scale/frontend-lib/errors';

export default class HTTPError<
  TResponse extends { status: number } = { status: number },
> extends Error {
  response?: TResponse;
  status?: number;

  logError(errorType: any, ignorableStatusCodes: number[] = [], extra = {}) {
    captureServerSideError(this.response, errorType, ignorableStatusCodes, extra);
  }

  constructor(text: string, response?: TResponse) {
    super(text);
    this.response = response;
    this.status = response && response.status;
  }
}
